export default __webpack_public_path__ + "static/media/element_56.183bbf8a.jpg";